import React from 'react';
import OutputLine from "./OutputLine";
import {observer} from "mobx-react";
import PropTypes from "prop-types";
import MenuListOutput from "./MenuListOutput";

const propTypes = {
	indentLevel: PropTypes.number.isRequired,
	isHighlighted: PropTypes.bool,
	menu: PropTypes.arrayOf(PropTypes.object).isRequired,
};
const defaultProps = {
	isHighlighted: false,
};

const IconMenuOutput = ({indentLevel, isHighlighted, menu}) => {
	return (
		<>
			<OutputLine indent={indentLevel} forceHighlighted={isHighlighted}>
				{`menu: [`}
			</OutputLine>

			<MenuListOutput indentLevel={indentLevel + 1} isHighlighted={isHighlighted} menu={menu}/>

			<OutputLine indent={indentLevel} forceHighlighted={isHighlighted}>
				{`],`}
			</OutputLine>
		</>
	);
};

IconMenuOutput.propTypes = propTypes;
IconMenuOutput.defaultProps = defaultProps;

export default observer(IconMenuOutput);
